export enum JobFunction {
  CUSTOMER_SUPPORT = 'CUSTOMER_SUPPORT',

  SALES = 'SALES',

  TECHNICAL_SUPPORT = 'TECHNICAL_SUPPORT',

  OTHERS = 'OTHERS',
}
